import { Popover, Transition } from "@headlessui/react";
import { useRef, Fragment } from "react";

type Props = {
  text: string;
  children: React.ReactNode;
  delay?: number;
};

const DEFAULT_DELAY_MS = 500;

function Tooltip({ text, children, delay = DEFAULT_DELAY_MS }: Props) {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const timeOutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleEnter = (isOpen: boolean) => {
    timeOutRef.current = setTimeout(() => {
      !isOpen && triggerRef.current?.click();
    }, delay);
  };

  const handleLeave = (isOpen: boolean) => {
    if (timeOutRef.current) clearTimeout(timeOutRef.current);
    isOpen && triggerRef.current?.click();
  };

  return (
    <Popover className="relative">
      {({ open }) => (
        <div
          onMouseEnter={() => handleEnter(open)}
          onMouseLeave={() => handleLeave(open)}
        >
          <Popover.Button ref={triggerRef} className="outline-none">
            {children}
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute left-1/2 z-50 mt-3 flex w-32 -translate-x-1/2 transform justify-center rounded-lg bg-black p-2 px-4 text-center text-white">
              {text}
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
}

export default Tooltip;
